import { useUserContext } from '@providers/useUserContext';
import { Auth } from 'components/Auth';
import('react-phone-number-input/style.css');

const AuthScreen = () => {
  const { isLoggedIn } = useUserContext();

  if (isLoggedIn) {
    return <Auth.Logout />;
  }

  if (mondayMindbody?.oauth?.enabled) {
    return <Auth.OAuth />;
  }

  return <Auth.Firebase />;
};

export default AuthScreen;
